import { makeNoteAPIs } from '../../modules/noteAPIFactory'
import { getLocationNoteListData } from './mockData'
import type { ILocationNote } from '~/types/note/models'

export const {
  getNotes: getLocationNotes,
  postNote: postLocationNote,
  patchNote: patchLocationNote,
  deleteNote: deleteLocationNote,
  handlers,
} = makeNoteAPIs<ILocationNote>({
  apiPathEntityNamePrefix: 'location',
  getNoteListDataFn: getLocationNoteListData,
})
